import { ThemeZIndices } from "styled-system";


export const zIndicesMap: ThemeZIndices = {
	NONE: 0,
	Z1: 1,
	Z2: 2,
	Z3: 3,
	Z4: 4,
	Z5: 5
};
